import { GmsSystemType } from '@cbgms/api/modules/enums'
import { IReleaseNote, IReleaseNoteURL } from '@cbgms/api/modules/releasenotes'
import { formatters } from '@cbgms/base/utils/datetime'
import { enumToOptions } from '@cbgms/base/utils/helpers'
import { isRequired, isValidURL } from '@cbgms/base/utils/validations'
import { ReduxDateTimePicker as DateTimePicker } from '@cbgms/components/form/DateTimePickerBasic'
import Dropdown from '@cbgms/components/form/Dropdown'
import Input from '@cbgms/components/form/Input'
import Checkbox from '@cbgms/components/form/Checkbox'
import FormLayout from 'core/page/layout/FormLayout'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FieldArray, WrappedFieldArrayProps } from 'redux-form'
import { Form, Grid, Header, Segment } from 'semantic-ui-react'

interface IReleaseNotesFormProps {
  initialValues: IReleaseNote
  redirectToURL?: string
  onSubmit: (values: IReleaseNote) => any
  onSubmitAndDone?: (values: IReleaseNote) => any
  onSubmitSuccess: () => Promise<unknown>
  form: string
}

interface URLFieldProps extends WrappedFieldArrayProps<IReleaseNoteURL> {
  initialValues: any
}
/* eslint-disable */
//disable eslint conflicting react fragment and typescript error
const URLField: React.FC<URLFieldProps> = ({ fields, initialValues }) => {
  return (
    <React.Fragment>
      {fields &&
        fields.map((field, index) => (
          <Input
            key={field}
            label={initialValues.URLs[index].Country}
            name={`${field}.URL`}
            required
            validate={[isRequired, isValidURL]}
            maxLength='150'
          />
        ))}
    </React.Fragment>
  )
}
/* eslint-enable */

const ReleaseNotesForm: React.FC<IReleaseNotesFormProps> = ({
  form,
  onSubmit,
  onSubmitAndDone,
  initialValues,
  onSubmitSuccess,
  redirectToURL
}) => {
  const { t } = useTranslation()
  const systemOptions = enumToOptions(GmsSystemType, 'EnumGmsSystemType')

  return (
    <FormLayout
      form={form}
      redirectToURL={redirectToURL}
      onSubmit={onSubmit}
      onSubmitAndDone={onSubmitAndDone}
      initialValues={initialValues}
      onSubmitSuccess={onSubmitSuccess}
    >
      <Segment>
        <Grid>
          <Grid.Row>
            <Grid.Column width={8}>
              <Header>{t('releasenotes.information')}</Header>
              <Form.Group widths={2}>
                <Dropdown fluid selection required name='GmsSystemType' label={t('releasenotes.type')} options={systemOptions} />
                <Form.Field required>
                  <label>{t('releasenotes.status')}</label>
                  <Checkbox name='IsPublished' label={t('releasenotes.published')} />
                </Form.Field>
              </Form.Group>
              <DateTimePicker
                label={t('releasenotes.publishdate')}
                name='PublishDate'
                viewMode='years'
                timeFormat
                formatters={formatters.datetime}
                validate={isRequired}
                required
              />
            </Grid.Column>
            <Grid.Column width={8}>
              <Header>{t('releasenotes.urls')}</Header>
              <Form.Group widths='2' data-testid='urls'>
                <FieldArray name='URLs' component={URLField} initialValues={initialValues} />
              </Form.Group>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Segment>
    </FormLayout>
  )
}

ReleaseNotesForm.displayName = 'ReleaseNotesForm'

export default ReleaseNotesForm
